import { render, staticRenderFns } from "./WeightRecords.vue?vue&type=template&id=dc3f27ca&scoped=true"
import script from "./WeightRecords.vue?vue&type=script&lang=js"
export * from "./WeightRecords.vue?vue&type=script&lang=js"
import style0 from "./WeightRecords.vue?vue&type=style&index=0&id=dc3f27ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc3f27ca",
  null
  
)

export default component.exports